import { GraduationCap } from "lucide-react";
import { formationOrderHref } from "@/components/formation/FormationHome";
import { formationPrice } from "@/lib/formation";

/** Bandeau du haut : formation en ligne, lien direct vers l'inscription sur ozentyaformation.com. */
export function FormationBar() {
  const p = formationPrice();
  return (
    <a href={formationOrderHref("bandeau")} target="_blank" rel="noopener" data-testid="formation-bar"
      className="flex h-9 items-center justify-center gap-3 overflow-hidden whitespace-nowrap border-b border-black/20 bg-[#141013] px-3 text-[11px] font-semibold uppercase tracking-[0.12em] text-[var(--gold-soft)] md:text-xs">
      <GraduationCap className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="md:hidden">Formation cheveux afro{p ? ` · ${p.now} €` : ""}</span>
      <span className="hidden md:inline">Formation en ligne Méthode Ozentya : connaissez enfin votre cheveu{p ? ` · ${p.now} € pour le moment, ${p.after} € le ${p.until}` : ""}</span>
      <span className="rounded-full bg-[var(--gold)] px-3 py-0.5 text-[var(--ink)]">Je m'inscris</span>
    </a>
  );
}
